// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Uozc","header":"ReportDetails_header__2le6s","title":"ReportDetails_title__kM9H-","left":"ReportDetails_left__32Yez"};